import {ref} from "firebase/database";
import database from ".";

export const getTypingRef = (conversationId, userId) => {
    return ref(database, `/typing/${conversationId}_${userId}`);
};
